import React, { createContext, useContext } from 'react';

interface EventThemeValue {
  /** True when there is an active event — enables the cosmic dark theme. */
  isCosmicTheme: boolean;
  /** The ID of the currently active event, if any. */
  activeEventId?: number;
  /** True when the juryScores config key is enabled on the active event. */
  juryVotingEnabled: boolean;
}

const EventThemeContext = createContext<EventThemeValue>({
  isCosmicTheme: false,
  activeEventId: undefined,
  juryVotingEnabled: false,
});

export const EventThemeProvider = ({
  isCosmicTheme,
  activeEventId,
  juryVotingEnabled,
  children,
}: EventThemeValue & { children: React.ReactNode }) => (
  <EventThemeContext.Provider
    value={{ isCosmicTheme, activeEventId, juryVotingEnabled }}
  >
    {children}
  </EventThemeContext.Provider>
);

export const useEventTheme = () => useContext(EventThemeContext);
